import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { MatPaginator, MatSort, MatSnackBar } from '@angular/material';
import { UsersService } from '../../../../core/services/users/users.service';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FuseUtils } from '../../../../core/fuseUtils';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'fuse-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  animations : fuseAnimations
})
export class UsersComponent implements OnInit {

    dataSource: FilesDataSource | null;
    displayedColumns = ['email', 'role', 'blocked'];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private usersService: UsersService,
        public snackBar: MatSnackBar,
    ) {}

    ngOnInit()
    {
        this.dataSource = new FilesDataSource(this.usersService, this.paginator, this.sort);
        this.usersService.list();
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
                  .debounceTime(150)
                  .distinctUntilChanged()
                  .subscribe(() => {
                      if ( !this.dataSource )
                      {
                          return;
                      }
                      this.dataSource.filter = this.filter.nativeElement.value;
                  });
    }


    refresh() {
        this.usersService.list();
    }

    /**
     * Delete
     */
    disable(id)
    {
        // this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
        //     disableClose: false
        // });

        // this.confirmDialogRef.componentInstance.confirmMessage = `Veuillez confirmer l'annulation de votre réservation ?`;

        // this.confirmDialogRef.afterClosed().subscribe(result => {
        //     if ( result )
        //     {
                this.usersService.disable(id).toPromise().then(() => {
                    this.refresh();
                    this.snackBar.open(`Compte désactivé.`, 'OK', {
                        verticalPosition: 'top',
                        duration        : 3000
                    });
                }).catch(e => {
                    this.snackBar.open(`Désactivation impossible, une erreur est survenue.`, 'OK', {
                        verticalPosition: 'top',
                        duration        : 3000
                    });
                });
        //     }
        //     this.confirmDialogRef = null;
        // });

    }

    enable(id)
    {
                this.usersService.enable(id).toPromise().then(() => {
                    this.refresh();
                    this.snackBar.open(`Compte activé.`, 'OK', {
                        verticalPosition: 'top',
                        duration        : 3000
                    });
                }).catch(e => {
                    this.snackBar.open(`Désactivation impossible, une erreur est survenue.`, 'OK', {
                        verticalPosition: 'top',
                        duration        : 3000
                    });
                });
        //     }
        //     this.confirmDialogRef = null;
        // });

    }
}

export class FilesDataSource extends DataSource<any>
{
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any
    {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any)
    {
        this._filteredDataChange.next(value);
    }

    get filter(): string
    {
        return this._filterChange.value;
    }

    set filter(filter: string)
    {
        this._filterChange.next(filter);
    }

    constructor(
        private usersService: UsersService,
        private _paginator: MatPaginator,
        private _sort: MatSort,
    )
    {
        super();
        this.filteredData = this.usersService.users;
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]>
    {
        const displayDataChanges = [
            this.usersService.onUsersChanged,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.usersService.users.slice();

            data = this.filterData(data);

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    filterData(data)
    {
        if ( !this.filter )
        {
            return data;
        }
        return FuseUtils.filterArrayByString(data, this.filter);
    }

    sortData(data): any[]
    {
        if ( !this._sort.active || this._sort.direction === '' )
        {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch ( this._sort.active )
            {
                case '_id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'email':
                    [propertyA, propertyB] = [a.email, b.email];
                    break;
                // case 'parentCategory':
                //     [propertyA, propertyB] = [a.parentCategory.title, b.parentCategory.title];
                //     break;
                // case 'category':
                //     [propertyA, propertyB] = [a.category.title, b.category.title];
                //     break;
                // case 'quantity':
                //     [propertyA, propertyB] = [a.quantity, b.quantity];
                //     break;
                case 'blocked':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect()
    {
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/users/users.component.ts